<ng-container *ngIf="fetchedCategories$ | async as categories">
  <ng-container *ngIf="categories && categories.length && categories[0]">
    <div class="card-outer">


    <div class="category-card">
      <div class="card-image">
        <img
          *ngIf="categories[0]?.images?.[0]?.effectiveUrl"
          [src]="categories[0]?.images?.[0]?.effectiveUrl"
          alt="{{ categories[0]?.name }}"
        />
        <img
          *ngIf="!categories[0]?.images?.[0]?.effectiveUrl"
          src="/assets/img/not-available.svg"
          alt="Image not found"
        />
      </div>

      <div class="card-footer">
        <a
          *ngIf="categories[0]?.uniqueId"
          [routerLink]="['/category', categories[0]?.uniqueId]"
          class="footer-title-link"
        >
          <h2 class="footer-title">{{ categories[0]?.name }}</h2>
        </a>
      </div>

      <div class="card-body">
        <div class="white-backdrop"></div>
        <div class="card-content">
          <ul class="subcategory-list">
            <li *ngFor="let child of categories.slice(1); let i = index" [style.--index]="i">
              <a [routerLink]="['/category', child.uniqueId]" class="subcategory-link">
                <span class="arrow">▶</span> {{ child.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </ng-container>
</ng-container>
